var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501:3324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4161 5.79991L10.674 5.09081L8.55008 0.655537C8.44439 0.430535 8.21257 0.287352 7.96711 0.287352C7.72166 0.287352 7.48984 0.430535 7.38416 0.655537L5.26027 5.09081L0.518174 5.79991C0.276126 5.83741 0.0749878 6.00446 -1.29566e-05 6.23628C-0.0784229 6.4681 -0.0170581 6.72378 0.156807 6.89765L3.60003 10.3579L2.78524 15.2466C2.74433 15.4921 2.84661 15.7341 3.04775 15.8807C3.25229 16.0239 3.5148 16.0409 3.73298 15.9216L7.96711 13.6273L12.2013 15.9216C12.3001 15.9762 12.4058 16 12.5115 16C12.6444 16 12.774 15.9591 12.8865 15.8773C13.091 15.7341 13.1899 15.4886 13.149 15.2432L12.3342 10.3545L15.7774 6.89424C15.9513 6.72037 16.0092 6.4681 15.9342 6.23287C15.8592 6.00446 15.6615 5.83741 15.4161 5.79991Z",
    fill: "#A4A6B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501:3324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMenuIcon);
export default __webpack_public_path__ + "static/media/star-menu-icon.09d8da6fbacd5893b6e3ed2473f26d41.svg";
export { ForwardRef as ReactComponent };